// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3EM-l","file":"styles_file__mFF8q"};